import React from 'react';
import styles from './layout.module.scss'
import { AppContent } from './components/content';
import { AppLeftNav } from './components/left-nav';

export const AppLayout = () => {
  return (
	<div className={styles.layout}>
	  <AppLeftNav />
	  <AppContent />
	</div>
  );
};
